<template>
  <v-container fluid>
    <PageTitle>
      <v-icon left>
        fas fa-fw fa-building
      </v-icon>
      Teams
      <template v-slot:buttons>
        <v-btn @click.prevent="hideDetails = !hideDetails"
               tile>
          {{ hideDetails ? 'Show Details' : 'Hide Details' }}
        </v-btn>
      </template>
    </PageTitle>

    <template v-if="isEmployee">

      <v-card class="mb-4">
        <v-card-title>
          Active Demo Teams
        </v-card-title>
        <TeamsTable :loading="teamsLoading"
                    :teams="activeDemo"
                    :hide-details="hideDetails"
                    :hide-default-footer="true"
                    :items-per-page="-1"
                    @updated="fetchData"
                    class="border">
        </TeamsTable>
      </v-card>

      <v-card class="mb-4">
        <v-card-title>
          Active Customers
        </v-card-title>
        <TeamsTable :loading="teamsLoading"
                    :teams="activeCustomers"
                    :hide-details="hideDetails"
                    :hide-default-footer="true"
                    :items-per-page="-1"
                    @updated="fetchData"
                    class="border">
        </TeamsTable>
      </v-card>

      <v-card class="mb-4">
        <v-card-title>
          Active Partners
        </v-card-title>
        <TeamsTable :loading="teamsLoading"
                    :teams="activePartners"
                    :hide-details="hideDetails"
                    :hide-default-footer="true"
                    :items-per-page="-1"
                    @updated="fetchData"
                    class="border">
        </TeamsTable>
      </v-card>

      <v-card class="mb-4">
        <v-card-title>
          Expired Teams
        </v-card-title>
        <TeamsTable :loading="teamsLoading"
                    :teams="expiredTeams"
                    :hide-details="hideDetails"
                    :hide-default-footer="true"
                    :items-per-page="-1"
                    @updated="fetchData"
                    class="border">
        </TeamsTable>
      </v-card>

    </template>

    <template v-else>

      <v-card class="mb-4">
        <TeamsTable :loading="teamsLoading"
                    :teams="activeTeams"
                    :hide-default-footer="true"
                    :items-per-page="-1"
                    @updated="fetchData"
                    class="border">
        </TeamsTable>
      </v-card>

    </template>

  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import TeamsTable from './components/TeamsTable';
import {orderBy} from 'lodash';
import PageTitle from "../../components/PageTitle";

export default {
  components: {PageTitle, TeamsTable},
  data() {
    return {
      hideDetails: false,
      form: new Form({}),
    }
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'isEmployee',
      'isSuperAdmin',
      'teamsLoading',
      'teams',
      'user',
    ]),
    activeCustomers() {
      return orderBy(this.activeTeams.filter(t => t.is_customer), ['name'], ['asc']);
    },
    activeDemo() {
      return orderBy(this.activeTeams.filter(t => t.is_demo), ['name'], ['asc']);
    },
    activePartners() {
      return orderBy(this.activeTeams.filter(t => t.is_partner), ['name'], ['asc']);
    },
    activeTeams() {
      return orderBy(this.teams.filter(t => (t.is_active && t.is_license_active)), ['team_type', 'name'], ['asc', 'asc']);
    },
    expiredTeams() {
      return this.teams.filter(t => (!t.is_active || !t.is_license_active));
    },
  },
  created() {
    this.hideDetails = this.isEmployee;
  },
  methods: {
    fetchData() {
      this.$store.dispatch('fetchTeams');
    }
  }
}
</script>
